import React, { useContext } from 'react';
import { Layout, Breadcrumb, Row, Dropdown, Menu, Typography } from 'antd';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";

import { userLogout } from '../Services';
import { AuthContext } from '../Context/AuthContext';

const { Text } = Typography;
const { Header, Content, Footer } = Layout;

const PageLayout = ({ children, title }) => {
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    userLogout(navigate);
  }

  const menu = (
    <Menu>
      <Menu.Item key="Logout" icon={<LogoutOutlined />} onClick={handleLogout}>Logout</Menu.Item>
    </Menu>
  );

  return (
    <Layout className="site-layout">
      <Header className="header-background">
        <Row justify='end' align="middle" style={{ paddingRight: 10 }}>
          <Dropdown.Button
            type="text"
            overlay={menu}
            placement="bottom"
            icon={<UserOutlined style={{ color: "#FFF" }} />}
          >
            <Text style={{ color: "#FFF" }}>{(authContext?.user?.email || "")}</Text>
          </Dropdown.Button>
        </Row>
      </Header>
      <Content style={{ margin: '0 16px' }}>
        <Breadcrumb style={{ margin: '16px 0' }}>
          <Breadcrumb.Item>Home</Breadcrumb.Item>
          <Breadcrumb.Item>{title}</Breadcrumb.Item>
        </Breadcrumb>
        <div>
          {children}
        </div>
      </Content>
      <Footer style={{ textAlign: 'center' }}>Ant Design ©2018 Created by Ant UED</Footer>
    </Layout>
  );
}

export default PageLayout;